import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "The Theron Family",
    description: "The family tree, history and shared memories of the Theron family, centred on Marga Theron. Explore every branch and add a story of your own.",
    url: getOrigin(),
    ogImage: "https://glossy-fern-10a.cdn.modulify.website/images/hero-family-photos.jpg"
}
